import React, {useState, useEffect, useContext, useRef} from 'react';
import { useNavigate } from "react-router-dom";

import Stack from 'react-bootstrap/Stack';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FormContext } from 'context/FormContext';
import RadioButton from 'components/formElements/RadioButton';
import Label from 'components/formElements/Label';
import RangeSlider from 'components/formElements/RangeSlider';
import iconCross from 'assets/images/icon_circle_cross.svg';
import iconCheck from 'assets/images/icon_circle_checkmark_grey.svg';
import iconCalendar from 'assets/images/icon_calendar.svg';
import defaultValues from 'forms/defaultValues';

const HeatingPump = () => {
    const { formValues, setFormValues } = useContext(FormContext);
    const [ errors, setErrors] = useState({});
    const hasInitialized = useRef(false);
    const navigate = useNavigate();

    const [ isNew ] = useState(formValues.hasOwnProperty('createHeatingPump') && formValues.createHeatingPump === 1);

    useEffect(() => {
        if ('createHeatingPump' in formValues) {
            // const { createHeatingPump, ...rest } = formValues;
            // setFormValues(rest);
            setFormValues(prevState => {
                const newFormValues = { ...prevState };                       
                delete newFormValues.createHeatingPump;               
                return newFormValues;
            });
        }
    }, []); // empty deps to run once on mount

    // useEffect(() => {
    //     if (!hasInitialized.current) {
    //       hasInitialized.current = true;
    //       if (!formValues.hasOwnProperty('energyUseHeatingPump') || formValues.energyUseHeatingPump === 0) {
    //         setFormValues(prev => ({
    //             ...prev,
    //             energyUseHeatingPump: 1,
    //             // UsableSquareMeter: defaultValues.UsableSquareMeter,
    //             // HeatingPumpConsumption: defaultValues.HeatingPumpConsumption,
    //             // ConstructionYear: defaultValues.ConstructionYear,
    //             // RenovationYear: defaultValues.RenovationYear,
    //             // EnergyRenovation: defaultValues.EnergyRenovation
    //         }));
    //       }
    //     }
    // }, []);

    const handleUserInput = (e) => {
        const { name, type, checked, value } = e.target;
        const finalValue = type === "checkbox" ? checked : value;
        setFormValues({ ...formValues, [e.target.name]: finalValue });
        validateField(name, finalValue);
    }

    const isValidYear = (value) => {
        return !(!value || isNaN(value) || !Number.isInteger(Number(value)) || value < 1900 || value > new Date().getFullYear());
    }

    const validateField = (name, value) => {
        let newErrors = { ...errors };

        switch (name) {
            case 'ConstructionYear':
                if (!isValidYear(value)) {
                    newErrors.ConstructionYear = true;
                } else {
                    delete newErrors.ConstructionYear;
                }
                break;
            case 'RenovationYear':
                if (!isValidYear(value)) {
                    newErrors.RenovationYear = true;
                } else {
                    delete newErrors.RenovationYear;
                }
                break;
            default:
                break;
        }
        setErrors(newErrors);
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formValues.ConstructionYear || !isValidYear(formValues.ConstructionYear)) {
            newErrors.ConstructionYear = true;
        }
        if (formValues.EnergyRenovation === "Ja") {
            if (!formValues.RenovationYear || !isValidYear(formValues.RenovationYear) ) {
                newErrors.RenovationYear = true;
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const cancel = (e) => {
        // @todo: only remove if heating pump did not exist before
        // console.log('isNew', isNew);
        if (isNew) {
            setFormValues(prevState => {
                const newFormValues = { ...prevState };
                newFormValues.energyUseHeatingPump = 0;                                        
                return newFormValues;
            });
        }
        // setFormValues(prevState => {
        //     const newFormValues = { ...prevState };                       
        //     delete newFormValues.createHeatingPump;               
        //     return newFormValues;
        // });
        navigate("/EnergyConsumption");
    }

    const submitForm = () => {
        // setFormValues(prevState => {
        //     const newFormValues = { ...prevState };                       
        //     delete newFormValues.createHeatingPump;               
        //     return newFormValues;
        // });
        if (validateForm()) {
            navigate("/EnergyConsumption");
        }
    }

    return (
        <Stack gap={4} className="ContainerPaddingSmall text-center">
            <h1>Wärmepumpe hinzufügen</h1>
            <div>Bitte geben Sie Ihre Nutzfläche und Baujahr Ihres Hauses sowie den Verbrauch Ihrer Wärmepumpe an.</div>
            <Row md="2" xs="1">
                <Col>
                    <RangeSlider name="UsableSquareMeter" label="Nutzfläche Ihres Hauses" unit="m²" default="120" max="350" min="90" />
                </Col>
                <Col>
                    <Label text="Baujahr des Hauses" className="mb-2 mt-5 mt-md-0 " />
                    <InputGroup className="mb-3 mt-2 mt-md-0 ">
                        <Form.Control
                            className="short"
                            name="ConstructionYear"
                            defaultValue={formValues.ConstructionYear}
                            onChange={handleUserInput}
                            isInvalid={!!errors.ConstructionYear}
                        />
                        <InputGroup.Text><img src={iconCalendar} alt="Baujahr" /></InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>
            <Row md="2" xs="1">
                <Col>
                    <RangeSlider className="" name="HeatingPumpConsumption" label="Verbrauch der Wärmepumpe" unit="kWh" default="4200" max="10000" min="2000" />
                </Col>
                <Col>
                    <Label text="Gab es eine energetische Sanierung?" className="mb-2 mt-5 mt-md-0 " />
                    <Stack gap={3} direction="horizontal" className="">
                        <RadioButton name="EnergyRenovation" label="Ja" value="Ja" image={iconCheck} />
                        <RadioButton name="EnergyRenovation" label="Nein" value="Nein" image={iconCross} />
                    </Stack>
                    {formValues.EnergyRenovation === "Ja" &&
                        <InputGroup className="mt-3">
                            <Form.Control
                                name="RenovationYear"
                                className="short"
                                defaultValue={formValues.RenovationYear}
                                onChange={handleUserInput}
                                isInvalid={!!errors.RenovationYear}
                            />
                            <InputGroup.Text><img src={iconCalendar} alt="Sanierungsjahr" /></InputGroup.Text>
                        </InputGroup>
                    }
                </Col>
            </Row>
            <Stack gap={3} direction="horizontal" className="mt-4 flex-column flex-md-row button-group align-items-start">
                <Button onClick={cancel} variant="outline-light">Abbrechen</Button>
                <Button onClick={submitForm} variant="success">Wärmepumpe hinzufügen</Button>
            </Stack>
        </Stack>
    );
}

export default HeatingPump;